import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { checkIsNumber, formatNumber, parseUnknownToNumber } from "@tsp-core/utils/number";

import { CurrencyId, CurrencySymbol } from "../enums";
import { Money, StorableMoney } from "../types";

export function parseCurrencyId<Input extends unknown>(
  input: Input,
): Input extends CurrencyId ? CurrencyId : CurrencyId | null {
  const id = parseUnknownToNumber(input, "integer");
  if (checkIsNotNullish(id)) {
    return id as CurrencyId;
  }

  return null as any;
}

export function transformFromStorableMoney<Input>(input: Input): Input extends StorableMoney ? Money : Money | null {
  const value = parseUnknownToNumber(input, "integer");
  if (typeof value !== "number") {
    return null as any;
  }

  return (value / 100) as Money;
}

export function transformToStorableMoney<Input>(
  input: Input,
): Input extends Money ? StorableMoney : StorableMoney | null {
  const value = parseUnknownToNumber(input, "float");
  if (typeof value !== "number") {
    return null as any;
  }

  return Math.round(value * 100) as StorableMoney;
}

export function getCurrencySymbol(currencyId: CurrencyId): CurrencySymbol {
  return CurrencySymbol[CurrencyId[currencyId] as keyof typeof CurrencySymbol];
}

export function formatMoney(input: Money | null, currencyId: CurrencyId, fallback = "-"): string {
  if (!checkIsNumber(input)) {
    return fallback;
  }

  const isNegative = input < 0;
  const prefix = isNegative ? "-" : "";

  const symbol = getCurrencySymbol(currencyId);
  const humanizedNumber = formatNumber(Math.abs(input) as Money, ".");

  return `${prefix}${symbol}${humanizedNumber}`;
}
